import { SaferpayFieldTypeEnum, SaferpayFieldValidationReason } from '../enums';

export type SaferpayFieldsFieldValidation = {
  event: string;
  fieldType: SaferpayFieldTypeEnum;
  id: string;
  isValid?: boolean;
  reason?: SaferpayFieldValidationReason;
};

export type SaferpayFieldsValidation = {
  [key: string]: SaferpayFieldsFieldValidation;
};

export type SaferpayFieldsFieldGlossary = {
  field: SaferpayFieldTypeEnum;
  text: string;
};
